import { Transformer } from "../../../../Transformer/index.js";

export class LoginTypeService {
  constructor() {
    this.transformer = new Transformer();
  }
  async get(args) {
    return await this.transformer.getGrid(this, "getLocal", args);
  }

  getLocal(args) {
    let providers = [
      {label: "Microsoft", value: "Microsoft"},
      {label: "Cookies", value: "Cookies"},
    ];

    let availableEnvironment = ["K8sBareMetal", "YandexCloudDev", "Development"];
    let environment = process.env.VUE_APP_ENVIRONMENT || config.VUE_APP_ENVIRONMENT;
    
    if (availableEnvironment.includes(environment))
      providers.push({label: "ADFS", value: "OpenIdConnect"})

    const data = {
      data: {
        records: providers
      }
    }
    return { data };
  }
  
}
